import { BaseQueryApi } from '@reduxjs/toolkit/query/react'

import type { RootState } from '../../store'

export const prepareAuthenticatedHeaders = (
  headers: Headers,
  { getState }: Pick<BaseQueryApi, 'getState' | 'extra' | 'endpoint' | 'type' | 'forced'>
) => {
  // By default, if we have a token in the store, let's use that for authenticated requests
  const { token } = (getState() as RootState).store
  if (token) {
    headers.set('authorization', `Token ${token}`)
  }
  return headers
}
